module.exports = __webpack_public_path__ + "static/media/research_two.5d20579d.psd";